<script>
import ModalCloseButton from '@maison/components/common/ModalCloseButton.vue';
import PictureLazy from '@maison/components/common/PictureLazy';
import Modal from '@phoenix/mixins/components/common/Modal';

export default {
  components: {
    ModalCloseButton,
    PictureLazy,
  },

  mixins: [Modal],

  props: {
    // TODO: to remove when styleguide will resolve https://agile.richemont.com/jira/browse/JLCP-1729
    isOverflowInitial: {
      type: Boolean,
      default: false,
    },
    cover: {
      type: Object,
      default: null,
    },
    headerBordered: {
      type: Boolean,
      default: false,
    },
    overlayPadded: {
      type: Boolean,
      default: false,
    },
    containerClasses: {
      type: Array,
      default: () => [],
    },
    overlayClasses: {
      type: Array,
      default: () => [],
    },
    subtitle: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    overrideForOverflow: {},
  }),

  computed: {
    _overlayClasses() {
      return [
        'modal__overlay',
        {
          'modal__overlay--padded': this.overlayPadded || this.card,
          'modal-scrollable__overlay': this.scrollable,
        },
        ...this.overlayClasses,
      ];
    },

    _containerClasses() {
      return [
        'modal__container',
        {
          'modal-scrollable__container': this.scrollable,
        },
        ...this.containerClasses,
      ];
    },

    titleClasses() {
      return ['modal__title', this.card ? 'h3' : 'h5'];
    },

    containerStyle() {
      return this.isOverflowInitial ? { 'overflow-x': 'initial', 'overflow-y': 'initial' } : {};
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div :class="_overlayClasses" tabindex="-1">
      <div
        :class="_containerClasses"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="`${id}-title`"
        :data-cy="dataCy"
        :style="containerStyle"
      >
        <header v-if="shouldDisplayHeader" :class="_headerClasses">
          <div v-if="card && cover" class="picture picture--cover modal__header-picture bg-grey-200">
            <picture-lazy v-bind="cover"></picture-lazy>
          </div>

          <hgroup class="modal__titles">
            <h1 :id="`${id}-title`" :class="titleClasses">{{ title }}</h1>

            <p v-if="subtitle" class="h6 modal__subtitle">{{ subtitle }}</p>
          </hgroup>

          <slot v-if="isClosable && !closeButtonOutside" name="close-button">
            <modal-close-button :modal-id="id" />
          </slot>
        </header>

        <slot name="header" />

        <main v-if="shouldWrapContent" :id="`${id}-content`" :class="_contentClasses" :style="overrideForOverflow">
          <slot name="content" />
        </main>
        <slot v-else name="content" />

        <slot v-if="isClosable && closeButtonOutside" name="close-button">
          <modal-close-button :modal-id="id" />
        </slot>

        <footer v-if="hasFooterSlot" class="modal__footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>
